import React from 'react';
import { CompactPaymentWrapper, IconWrapper, DefaultWrapper, TightFitWrapper } from "./styles";
import { IconCard, IconPayPal, IconSepa } from "../Icons";













const mapTypeToContent = ({
  type = '',
  identifier = '',
  classNames = {} }) =>
{
  const maskedIdentifier = (identifier.replace(/.(?=.{4})/g, '•').match(/(.{1,4})/g) || []).join(
  ' ');

  let normalizedType = '';

  if (typeof type === 'string') {
    normalizedType = type.toLowerCase();
  }

  switch (normalizedType) {
    case 'card':
      return {
        extensionClassName: classNames.cardWrapper,
        WrapperComponent: DefaultWrapper,
        IconComponent: IconCard,
        paymentIdentifier: maskedIdentifier };

    case 'paypal':
      return {
        extensionClassName: classNames.payPalWrapper,
        WrapperComponent: TightFitWrapper,
        IconComponent: IconPayPal,
        paymentIdentifier: identifier };


    case 'sepa':
      return {
        extensionClassName: classNames.sepaWrapper,
        WrapperComponent: TightFitWrapper,
        IconComponent: IconSepa,
        paymentIdentifier: identifier };


    default:
      return {
        WrapperComponent: TightFitWrapper,
        icon: null,
        paymentIdentifier: identifier };}


};

export const CompactPaymentDisplay = ({
  className,
  classNames = {},
  type,
  identifier = '' }) =>
{
  const { paymentIdentifier, IconComponent, WrapperComponent, extensionClassName } =
  mapTypeToContent({
    type,
    identifier,
    classNames });

  return /*#__PURE__*/(
    React.createElement(CompactPaymentWrapper, { className: className }, /*#__PURE__*/
    React.createElement(IconWrapper, { className: classNames.iconWrapper },
    IconComponent ? /*#__PURE__*/React.createElement(IconComponent, null) : null), /*#__PURE__*/


    React.createElement(WrapperComponent, { className: extensionClassName }, paymentIdentifier)));


};